/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FachbereichInputs */

const en__field_fachbereich = /** @type {(inputs: _Field_FachbereichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Department`)
};

const de__field_fachbereich = /** @type {(inputs: _Field_FachbereichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachbereich`)
};

/**
* | output |
* | --- |
* | "Department" |
*
* @param {_Field_FachbereichInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_fachbereich = /** @type {((inputs?: _Field_FachbereichInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FachbereichInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_fachbereich(inputs)
	return de__field_fachbereich(inputs)
});